import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface UserData {
        id: number;
        userName: string;
        email: string;
        phoneNumber: number | null;
        azureToken: string | null;
        roleId: number;
        createdDate: string;
        updatedDate: string | null;
        status: boolean;
        isRegisteredUser: boolean;
      }

      export interface AddressData {
        id: number;
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        addressType: string;
        pinCode: string;
        blockCode: string;
        addressCode: string;
        latitude: string;
        longitude: string;
        createdDate: string;
    }

export const GetUsersByDateRangeAsync = async (fromDate: string, toDate: string, token: string): Promise<UserData[]> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/Admin/GetUsersByDateRangeAsync?fromDate=${fromDate}&toDate=${toDate}`;

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (!response.ok) {
        throw new Error(`Failed to fetch user data: ${response.status}`);
      }
  
      return await response.json();
    } catch (error) {
      // console.error('Error in GetUsersByDateRangeAsync:', error);
      throw error;
    }
  };
  